import React, { memo } from 'react';
import { View, StyleProp, ViewStyle, Pressable, GestureResponderEvent } from 'react-native';
import { MB_PressableStateCallbackType } from '@/components/general/pressable';

interface MB_OnHoverWrapperProps {
  /**
   * The content to be wrapped by the on-hover wrapper.
   */
  children: React.ReactNode | ((arg: MB_PressableStateCallbackType) => React.ReactNode);

  /**
   * The style of the wrapper.
   */
  wrapperStyle?: StyleProp<ViewStyle>;

  /**
   * The style of the wrapper when hovered.
   */
  onHoverWrapperStyleModifier?: StyleProp<ViewStyle>;

  /**
   * The callback to be invoked when the wrapper is pressed.
   */
  onPress?: (vent: GestureResponderEvent) => void;
}

const MB_OnHoverWrapper = memo((props: MB_OnHoverWrapperProps) => {
  return (
    <Pressable onPress={props.onPress}>
      {(pressableState: MB_PressableStateCallbackType) => {
        const onHoverStyle = !pressableState.hovered ? {} : props.onHoverWrapperStyleModifier ?? { backgroundColor: 'black' };

        return <View style={[props.wrapperStyle, onHoverStyle]}>{typeof props.children === 'function' ? <>{props.children(pressableState)}</> : <>{props.children}</>}</View>;
      }}
    </Pressable>
  );
});

export { MB_OnHoverWrapper };
export type { MB_OnHoverWrapperProps };
